import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect } from "react";
import { useQueryLoader } from "react-relay";
import { ThemeQuery } from "../Shared/components/BrandingProvider/ThemeQuery";
const initState = {
    themeQueryReference: null,
    loadThemeQuery: () => { },
    disposeThemeQuery: () => { },
};
export const PreloadedQueriesContext = createContext(initState);
// A provider component that triggers the preloading of queries and provides the preloaded queries to its children.
export const PreloadedQueriesProvider = ({ children }) => {
    // Preload the theme.
    const [themeQueryReference, loadThemeQuery, disposeThemeQuery] = useQueryLoader(ThemeQuery);
    // * additional preloaded queries can be added via additional useQueryLoader calls
    // const [anotherQueryReference, loadAnotherQuery, disposeAnotherQuery] = useQueryLoader(AnotherQuery);
    // ! recommended queries:
    // -- data for the Orders page
    // -- skip days (in general)
    // -- data for the MyMeals page
    if (!themeQueryReference) {
        loadThemeQuery({});
    }
    useEffect(() => {
        return () => {
            // Dispose of the query reference when the component unmounts.
            // Given the position of this provider, this will be one of the last components to unmount.
            // Any additional preloaded queries should be disposed of here as well.
            disposeThemeQuery();
        };
    }, [disposeThemeQuery]);
    return (_jsx(PreloadedQueriesContext.Provider, Object.assign({ value: { themeQueryReference, loadThemeQuery, disposeThemeQuery } }, { children: children })));
};
